import { Y200, Y300 } from '@atlaskit/theme/colors';
var boxShadowColorByStatus = {
  draft: "var(--ds-background-accent-yellow-subtle, ".concat(Y300, ")"),
  focus: "var(--ds-background-accent-yellow-subtle, ".concat(Y300, ")"),
  blur: "var(--ds-background-accent-yellow-subtler, ".concat(Y200, ")")
};
export var commentStatusStyleMap = function commentStatusStyleMap(status) {
  return "3px 3px 0px 0px ".concat(boxShadowColorByStatus[status]);
};